import React from "react";

import { FlexJustify } from "common/fragments/Flex";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { CardVariant, CardView } from "common/views/card/Card.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import IconView from "common/views/icon/Icon.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { RowsView } from "common/views/rows/Rows.view";
import { IQueryMany, QueryMany } from "core/api/query";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { isEmpty } from "core/util/ArrayUtils";
import OrganizationParticipant from "./entities/OrganizationParticipant";
import labelProvider from './OrganizationParticipant.labels';
import Config from "./OrganizationParticipantConfig";

const { Labels } = labelProvider;
@Panel({id: "organization-participant-list", configClass: Config, labelProvider})
@QueryMany(OrganizationParticipant, {})
export default class OrganizationParticipants extends React.PureComponent<IPanelProps<Config> & IQueryMany<OrganizationParticipant>> {

	public render() {
		if (isEmpty(this.props.entities)) {
			return (
				<NonIdealState
					title={<Labels.OrganizationNotFound />}
					description={<Labels.OrganizationNotfoundDescription />}
				/>
			);
		}

		return (
			<RowsView viewKey="rows">
				{this.props.entities.map(this.renderOrganization)}
			</RowsView>
		);
	}

	private renderOrganization = ({id, organization}: OrganizationParticipant) => {

			if (!organization) {
				return null;
			}

			return (
				<PageLinkView key={id} viewKey="link" params={{guid: organization.guid}}>
					<CardView variant={CardVariant.SURFACE} viewKey="card">
						<FlexJustify>
							<ImageView variant={ImageVariant.ICON} viewKey="icon" src={organization.logoURL} />
							<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-content">
								<HeadingView key="name" viewKey="name" children={organization.name} />
								{
									this.props.config.showUserCount && (
										<IconView icon="user" viewKey="users-icon">
											<Labels.OrganizationUserCount args={{UserCount : organization.userCount.count}}/>
										</IconView>
									)
								}
							</BlockView>
						</FlexJustify>
					</CardView>
				</PageLinkView>
			);
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizationParticipant/OrganizationParticipants.panel.tsx